class AccordionEvent {
  constructor() {
    this.event();
  }
  event() {

    if (window.matchMedia('(max-width: 767px)').matches) {
      //スマホ処理
      const elements = document.querySelectorAll(".s-gift__item02-inner");
      Array.from(elements).forEach(function (el) {
        //ボタンを取得
        const btn = el.querySelector(".more__btn");
        //コンテンツを取得
        const content = el.querySelector(".more__content");
        //ボタンクリックでイベント発火
        btn.addEventListener("click", function () {
          $('.more__btn').toggleClass('is-active');
          if (!content.classList.contains("open")) {
            //コンテンツの実際の高さを代入
            //キーワード値（none、max-content等）では動作しないので注意
            content.style.maxHeight = content.scrollHeight + "px";
            //openクラスを追加
            content.classList.add("open");
          } else {
            //コンテンツの高さを固定値を代入
            content.style.maxHeight = "27.5rem";
            //openクラスを削除
            content.classList.remove("open");
          }
        });
      });
    } else if (window.matchMedia('(min-width:768px)').matches) {
      //PC処理
      const elements = document.querySelectorAll(".s-gift__item02-inner");
      Array.from(elements).forEach(function (el) {
        //ボタンを取得
        const btn = el.querySelector(".more__btn");
        //コンテンツを取得
        const content = el.querySelector(".more__content");
        //ボタンクリックでイベント発火
        btn.addEventListener("click", function () {
          $('.more__btn').toggleClass('is-active');
          if (!content.classList.contains("open")) {
            //コンテンツの実際の高さを代入
            //キーワード値（none、max-content等）では動作しないので注意
            content.style.maxHeight = content.scrollHeight + "px";
            //openクラスを追加
            content.classList.add("open");
          } else {
            //コンテンツの高さを固定値を代入
            content.style.maxHeight = "32rem";
            //openクラスを削除
            content.classList.remove("open");
          }
        });
      });
    }
  }
}
